import { DataBean } from "../../../dataBean/DataBean";

export class PaymentFiles extends DataBean {
  public async reportPaymentFiles(idPaymentFiles: number, props: any): Promise<any> {
    return this.getCustomService("CreditCore", "com.credit.bean.PaymentFiles_reportPaymentFiles_Number_java.util.Map",
      [idPaymentFiles, props]
    );
  }
  public async reportPaymentByPeriodo(periodo: number, props: any): Promise<any> {
    return this.getCustomService("CreditCore", "com.credit.bean.PaymentFiles_reportPaymentByPeriodo_Number_java.util.Map",
      [periodo, props]
    );
  }

  public async getPaymentFilesReport(page: number, rows: number, props: any): Promise<any> {
    return this.getCustomService("CreditCore", "com.advantage.shared.Report_getPaymentFilesReport_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

}